import * as React from "react";
import { render } from "react-dom";
import { Provider } from "react-redux";
import HMRApp from "./HMR";
import * as sentry from "./lib/sentry";
import { store } from "./store";

sentry.init();

const rootEl = document.getElementById("root");

render(
    <sentry.ErrorBoundary fallback={<>An error has occurred</>}>
        <Provider store={store}>
            <HMRApp />
        </Provider>
    </sentry.ErrorBoundary>,
    rootEl
);
